import React from 'react';
export function GuaranteeSection() {
  return <section className="cv-auto bg-brand-dark py-24 px-4 border-t border-brand-border relative" data-id="element-121">
      <div className="absolute inset-0 bg-gradient-to-b from-brand-accent/5 via-brand-accent/10 to-brand-accent/5 pointer-events-none" data-id="element-122"></div>
      <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-123">
        <div className="flex justify-center mb-8" data-id="element-124">
          <div className="bg-brand-accent/10 border border-brand-accent/20 p-5 rounded-full text-5xl" data-id="element-125">
            🛡️
          </div>
        </div>
        <h2 className="text-3xl md:text-4xl font-heading font-bold mb-8 text-white" data-id="element-126">
          GARANTÍA <span className="text-brand-accent" data-id="element-127">PROFEPACK</span> — 7 DÍAS
        </h2>
        <div className="text-lg md:text-xl space-y-6 max-w-2xl mx-auto" data-id="element-128">
          <p className="text-white/70 bg-brand-card p-5 rounded-2xl border border-brand-border" data-id="element-129">
            Abrís los 12 tomos. Revisás los 6 bonos. Los usás en el aula si
            querés.
          </p>
          <p className="font-bold text-2xl text-white mt-8" data-id="element-130">
            Si en 7 días no es lo que esperabas:
          </p>
          <div className="py-4" data-id="element-131">
            <button onClick={() => document.getElementById('pricing')?.scrollIntoView({
            behavior: 'smooth'
          })} className="text-3xl md:text-4xl font-heading font-black text-brand-dark bg-brand-accent inline-block px-8 py-3 rounded-xl transform -rotate-1 cursor-pointer hover:scale-105 transition-transform" data-id="element-132">
              Te devolvemos el 100%.
            </button>
          </div>
          <p className="font-bold text-xl text-white/80" data-id="element-133">
            Sin preguntas. Sin formularios. Sin drama.
          </p>
          <p className="text-white/70 italic" data-id="element-134">
            La confianza que tenemos en PROFEPACK nos permite ofrecerte eso.
          </p>
          <p className="text-brand-accent font-bold mt-4" data-id="element-135">
            Más de 2.000 docentes de Matemática ya lo saben.
          </p>
        </div>
      </div>
    </section>;
}